import { Chip } from '@mui/material'
import {
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    Pending as PendingIcon,
    Block as BlockIcon,
} from '@mui/icons-material'

/**
 * Reusable StatusChip component
 * Displays status with appropriate color and icon
 * 
 * @param {string} status - Status value (active, inactive, pending, suspended, etc.)
 * @param {string} size - Chip size (small, medium)
 * @param {string} variant - Chip variant (filled, outlined)
 * @returns {JSX.Element} Styled chip component
 */
export function StatusChip({ status, size = 'small', variant = 'filled' }) {
    const statusLower = status?.toLowerCase() || ''

    const config = {
        active: { color: 'success', icon: <CheckCircleIcon fontSize="small" /> },
        inactive: { color: 'error', icon: <CancelIcon fontSize="small" /> },
        'on-leave': { color: 'warning', icon: <CancelIcon fontSize="small" /> },
        pending: { color: 'warning', icon: <PendingIcon fontSize="small" /> },
        suspended: { color: 'error', icon: <BlockIcon fontSize="small" /> },
        approved: { color: 'success', icon: <CheckCircleIcon fontSize="small" /> },
        rejected: { color: 'error', icon: <CancelIcon fontSize="small" /> },
        cancelled: { color: 'default', icon: <CancelIcon fontSize="small" /> },
        online: { color: 'success', icon: <CheckCircleIcon fontSize="small" /> },
        offline: { color: 'error', icon: <CancelIcon fontSize="small" /> },
        maintenance: { color: 'warning', icon: <PendingIcon fontSize="small" /> },
        completed: { color: 'success', icon: <CheckCircleIcon fontSize="small" /> },
        failed: { color: 'error', icon: <CancelIcon fontSize="small" /> },
        present: { color: 'success', icon: <CheckCircleIcon fontSize="small" /> },
        absent: { color: 'error', icon: <CancelIcon fontSize="small" /> },
        late: { color: 'warning', icon: <PendingIcon fontSize="small" /> },
        'early out': { color: 'warning', icon: <PendingIcon fontSize="small" /> },
        'half day': { color: 'warning', icon: <PendingIcon fontSize="small" /> },
    }

    const { color, icon } = config[statusLower] || {
        color: 'default',
        icon: null
    }

    const label = status?.charAt(0).toUpperCase() + status?.slice(1).replace('-', ' ')

    return (
        <Chip
            icon={icon}
            label={label}
            color={color}
            size={size}
            variant={variant}
        />
    )
}
